module.exports = __webpack_public_path__ + "static/media/bed_203.9cb399c0.png";